import React, { useState, useEffect } from "react";
import AvatarSelector from "./AvatarSelector";
import { connect } from "react-redux";
import { changeAvatar } from "../../../../services/user/actions";
import Loading from "../../../helpers/loading";
import withRouter from "../../../../withRouter";
function UserInfo(props) {
  const [avatarPopupOpen, setAvatarPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const openAvatarPopup = () => {
    setAvatarPopupOpen(true);
  };

  const handleAvatarChange = (e) => {
    setLoading(true);
    props
      .changeAvatar(props.user_info.auth_token, e.target.getAttribute("data-name"))
      .then((response) => {
        if (response && response.success) {
          props.updateUserInfo();
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    setAvatarPopupOpen(props.avatarPopup);
  }, [props.avatarPopup]);

  const { user_info } = props;

  return (
    <React.Fragment>
      {loading && <Loading />}
      <AvatarSelector
        avatarPopupOpen={avatarPopupOpen}
        handleAvatarChange={handleAvatarChange}
      />
      <div className="block-content block-content-full bg-light">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h2 className="font-w600 mb-10">{user_info.name}</h2>
            <p className="text-muted">
              {user_info.phone} <br /> {user_info.email}
            </p>
          </div>
          <div>
            {user_info.avatar == null ? (
              <img
                src="/assets/img/various/avatars/user2.gif"
                alt={user_info.name}
                style={{ width: "100px" }}
                onClick={openAvatarPopup}
              />
            ) : (
              <img
                src={`/assets/img/various/avatars/${user_info.avatar}.gif`}
                alt={user_info.name}
                style={{ width: "100px" }}
                onClick={openAvatarPopup}
              />
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = () => ({});

export default withRouter(connect(
  mapStateToProps,
  { changeAvatar }
)(UserInfo));
